import { useState } from "react";
import { apiClient } from "../../api/client";
import { useApiList } from "../../hooks/useApiList";
import type { CliqueOrigin } from "../../features/aotd/components/shared/CliqueAttribution";

export type ArtInfo = {
  title: string;
  createdBy: string;
  authorQuote: string;
  quoteHelp: number;
  filename: string;
  date: Date;
  views: number;
  emojis: string[];
  waybackMachineUrl?: string;
  origin?: CliqueOrigin;
};

export const useLoadInfo = () => {
  // Distinguishes "nothing came back" from "the request blew up" — the grid
  // needs that to pick between an empty state and an error notice.
  const [failed, setFailed] = useState(false);

  const { items: artInfos, loading } = useApiList<ArtInfo>({
    request: () => apiClient.get(`/api/art-of-the-day/all/info`),
    mapData: (data) => {
      if (data.message) {
        return [];
      }
      // assuming the response data is an array of art info objects
      return data.map((info: any) => ({
        title: info.title,
        createdBy: info.createdBy,
        authorQuote: info.authorQuote,
        quoteHelp: parseInt(info.quoteHelp),
        filename: info.filename,
        date: new Date(info.date),
        views: parseInt(info.views),
        emojis: info.emojis || [], // ensure emojis are mapped correctly
        waybackMachineUrl: info.waybackMachineUrl, // include wayback url if available
        origin: info.origin, // clique origin when the day came from an x-n450s site
      }));
    },
    onError: (error, { setItems, setLoading }) => {
      console.error("Error fetching INFO:", error);
      // useApiList leaves `loading` true unless the handler clears it, which
      // used to leave the gallery spinning forever on a failed fetch.
      setItems([]);
      setLoading(false);
      setFailed(true);
    },
  });

  return { artInfos, loading, failed };
};
